import React, { Component } from 'react'
import { isNullOrWhiteSpace } from '../Services/strings'
import { put } from '../Services/http'
import { readCookie, setCookie } from '../Services/cookieService'
import { uniqueCountryLangPairs } from '../constants'
import Select, { components } from 'react-select'
import { translate } from '../Services/translation'

class GeoLocationPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            geoLocationPopupIsVisible: false,
        }
        this.cookieSetting =
            'GeoLocationPopupDismissed-' + this.props.cookieName + '=true'
    }

    userChoiceHandler(value) {
        setCookie(this.props.cookieName, value)
        this.setState({ geoLocationPopupIsVisible: true })
    }

    isVisible() {
        return (
            this.state.geoLocationPopupIsVisible ||
            (readCookie(this.props.cookieName) == null &&
                !isNullOrWhiteSpace(this.props.geoIpCountryAlpha2) &&
                this.props.geoIpCountryAlpha2 !=
                    window.__litium.currentCountryAlpha2)
        )
    }

    CountryOption({ data, ...props }) {
        const { label, value, imgSrc } = data
        return (
            <components.Option {...props}>
                <img src={imgSrc} style={{ height: '26px' }} />
                <span style={{ marginLeft: '10px' }}>{label}</span>
            </components.Option>
        )
    }

    setBodyScroll(popupVisible) {
        if (popupVisible) {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden'
            document.getElementsByTagName('body')[0].style.height = '100vh'
        } else {
            document.getElementsByTagName('body')[0].style.overflow = 'auto'
            document.getElementsByTagName('body')[0].style.height = 'unset'
        }
    }

    render() {
        const visible = this.isVisible()
        const classNames =
            'geolocatiopopup' + (!visible ? ' geolocatiopopup--hidden' : '')
        return (
            visible &&
            (this.setBodyScroll(visible),
            (
                <div className={classNames}>
                    <div className="row geolocatiopopup__section">
                        <div className="geolocatiopopup__content">
                            <div className="geolocatiopopup__content__logo-container">
                                <img
                                    className="geolocatiopopup__content__logo"
                                    src={this.props.logo}
                                />
                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '30px',
                                    textAlign: 'center',
                                }}
                            >
                                <span className="geolocatiopopup__content__alertmessage">
                                    {this.props.alertMessage}
                                </span>
                                <br />
                                <a
                                    className="geolocatiopopup__content__geobutton"
                                    onClick={async (event) => {
                                        this.userChoiceHandler(
                                            `${this.props.geoIpCountryAlpha2}`
                                        )
                                        event.preventDefault()
                                        await put(
                                            `/api/navigation/setCountry/${this.props.geoIpCountryAlpha2}`
                                        )
                                        window.location =
                                            this.props.currentUserLocationUrl
                                    }}
                                    href={this.props.currentUserLocationUrl}
                                >
                                    {this.props.takeMeToGeoLocationMessage}
                                </a>
                            </div>
                            <div style={{ width: '100%' }}>
                                <Select
                                    components={{
                                        Option: this.CountryOption,
                                        SingleValue: this.CountryOption,
                                    }}
                                    options={Object.values(
                                        uniqueCountryLangPairs
                                    )}
                                    placeholder={this.props.chooseOtherCountryMessage?.toUpperCase()}
                                    onChange={async ({ value }) => {
                                        this.userChoiceHandler(`${value}`)
                                        await put(
                                            `/api/navigation/setCountry/${value}`
                                        )
                                        window.location =
                                            uniqueCountryLangPairs[value].href
                                    }}
                                    isSearchable={false}
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            padding: '15px 8px',
                                            justifyContent: 'center',
                                        }),
                                        control: (provided) => ({
                                            ...provided,
                                            borderRadius: 0,
                                            ':hover': {
                                                border: '1px solid black',
                                            },
                                            ':focus': {
                                                border: '1px solid black',
                                            },
                                            ':active': {
                                                border: '1px solid black',
                                            },
                                            borderColor: 'rgb(199, 199, 199)',
                                            boxShadow: 'none',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            fontWeight: 400,
                                            color: '#000000',
                                        }),
                                        option: (provided) => ({
                                            ...provided,
                                            margin: '8px 0px -6px 7px',
                                            padding: '4px 2px 0px 3px',
                                        }),
                                        indicatorContainer: (provided) => ({
                                            ...provided,
                                            color: 'rgb(199, 199, 199)',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: 0,
                                            top: '90%',
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ))
        )
    }
}

export default GeoLocationPopup
